import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export interface ICoHostInviteForm {
  name: string
  email: string
  transferOwnership?: boolean
}

/**
 * Sends an invitation to a user to join an event as a host, with optional ownership transfer.
 */
export async function inviteCoHost(inviteRequest: ICoHostInviteForm, eventVaultId?: number) {
  if (!eventVaultId)
    throw new Error("Missing `eventVaultId` when attempting to invite user. Please ensure `eventVaultId` is provided.")

  const response = await axios.post(`api/${eventVaultId}/invitation`, inviteRequest)

  return response.data?.Message
}

const INVITE_CO_HOST_KEY = "inviteCoHost"

export function useInviteCoHost(eventVaultId?: number) {
  return useMutation({
    mutationKey: [INVITE_CO_HOST_KEY],
    mutationFn: (inviteRequest: ICoHostInviteForm) => inviteCoHost(inviteRequest, eventVaultId),
  })
}
